import { useState, useEffect } from 'react'
import { styled } from '@linaria/react'

interface CountdownProps {
  onCountdownEnd: () => void
  startFrom: number
}

const Number = styled.p`
  @keyframes anim {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(12);
      opacity: 0;
    }
  }
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: anim 1s ease-in-out infinite;
  font-family: 'Avenir-Heavy';
  font-size: 16px;
  pointer-events: none;
  color: #fff;
`

const CountDown = ({ onCountdownEnd, startFrom }: CountdownProps) => {
  const [counter, setCounter] = useState<number>(startFrom)
  useEffect(() => {
    const timer = setInterval(() => {
      setCounter(prev => {
        if (prev - 1 === 0) {
          onCountdownEnd()
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  return <Number>{counter}</Number>
}
export default CountDown
